import React, { useEffect } from 'react';

export function Sidebarf() {
  useEffect(() => {
    // Get references to the sidebar elements
    const sidebar = document.querySelector('.muzi-navbar-mobile');
    const sidebarOpen = document.querySelector('.open-muzi-menu');
    const sidebarClose = document.querySelector('.close-muzi-nav');

    // Define the event listener functions
    const openSidebar = () => {
      sidebar.style.display = 'block';
    };

    const closeSidebar = () => {
      sidebar.style.display = 'none';
    };

    // Add event listeners to the open and close buttons
    sidebarOpen.addEventListener('click', openSidebar);
    sidebarClose.addEventListener('click', closeSidebar);

    // Clean up the event listeners when the component unmounts
    return () => {
      sidebarOpen.removeEventListener('click', openSidebar);
      sidebarClose.removeEventListener('click', closeSidebar);
    };
  }, []);

  return null; // or your JSX for the Sidebar component
}
